import { RouterLink } from 'common/ui/RouterLink';
import { pathsV2Creators } from 'core/services/navigation/usePathsV2';
import { useOrganizationConfig } from 'core/stores/hooks/useOrganizationConfig';
import { TrackingEventName } from 'services/tracking/constants';
import { useTracking } from 'services/tracking/hooks';
import { CandidateBatchStatus } from 'generated-graphql/types';

type SourcingAnalyseColumnButtonProps = {
  candidateBatchId: string;
  candidatesCount: number | null | undefined;
  status: CandidateBatchStatus;
};

export const SourcingAnalyseColumnButton: React.FC<
  SourcingAnalyseColumnButtonProps
> = ({ candidatesCount, candidateBatchId, status }) => {
  const { track } = useTracking();
  const organizationConfig = useOrganizationConfig();

  if (
    (candidatesCount !== null && candidatesCount !== undefined) ||
    status === CandidateBatchStatus.Draft
  ) {
    return <>{candidatesCount}</>;
  }

  // Internal sourcing takes priority over external sourcing
  if (organizationConfig?.internalSourcingEnabled) {
    return (
      <RouterLink
        to={pathsV2Creators.ANALYSE_CANDIDATE_PROFILE_LIST({
          candidateBatchId
        })}
        onClick={() =>
          track(TrackingEventName.AnalyseListInvite, {
            candidateBatchId
          })
        }
      >
        Invite
      </RouterLink>
    );
  }

  if (organizationConfig?.sourcingEnabled) {
    return (
      <RouterLink
        to={pathsV2Creators.ANALYSE_SOURCE_EXTERNAL_CANDIDATES({
          candidateBatchId
        })}
        onClick={() =>
          track(TrackingEventName.AnalyseListInvite, {
            candidateBatchId
          })
        }
      >
        Invite
      </RouterLink>
    );
  }

  return <></>;
};
